import { render, staticRenderFns } from "./Wordbook.vue?vue&type=template&id=7b9e06a0&scoped=true&"
import script from "./Wordbook.vue?vue&type=script&lang=js&"
export * from "./Wordbook.vue?vue&type=script&lang=js&"
import style0 from "./Wordbook.vue?vue&type=style&index=0&id=7b9e06a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9e06a0",
  null
  
)

export default component.exports